import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { ESCALATION_SEVERITY_LABELS, ESCALATION_SEVERITY } from '../constants';

const ESCALATION_SEVERITY_COLORS = {
  [ESCALATION_SEVERITY.LOW]: 'default',
  [ESCALATION_SEVERITY.MEDIUM]: 'info',
  [ESCALATION_SEVERITY.HIGH]: 'warning',
  [ESCALATION_SEVERITY.CRITICAL]: 'error',
};

const EscalationPriorityBadge = ({ severity }) => (
  <Chip
    label={ESCALATION_SEVERITY_LABELS[severity] || severity}
    color={ESCALATION_SEVERITY_COLORS[severity] || 'default'}
    size="small"
  />
);

EscalationPriorityBadge.propTypes = {
  severity: PropTypes.string.isRequired,
};

export default EscalationPriorityBadge;

